module.exports = __webpack_public_path__ + "static/media/zw.a78ecd6a.webp";